import * as React from "react";
import type { SVGProps } from "react";
const SvgCreditcard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#creditcard_svg__a)">
      <path d="M18 20H6a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4M6 6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2z" />
      <path d="M21 11H3a1 1 0 0 1 0-2h18a1 1 0 1 1 0 2M7 16a1 1 0 1 1 0-2 1 1 0 0 1 0 2M13 16h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2" />
    </g>
    <defs>
      <clipPath id="creditcard_svg__a">
        <path fill="#fff" d="M2 4h20v16H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCreditcard;
